import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import _map from 'lodash/map';

import { AppContext, EMPTY_OBJECT } from 'commons-ui';

import useService from '../../../useService';

import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../formConfig';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert, app } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateWebsiteUpdateInfo, getLudoVersionNumberOptions } = useService();

	const websiteOptions = _map(app.websites, (website: string) => ({ label: website, id: website }));

	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.VERSION_NUMBER].setRenderProps({ getOptions: getLudoVersionNumberOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.CONTROL_VERSION_NUMBER].setRenderProps({ getOptions: getLudoVersionNumberOptions });
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.WEBSITE_NAME].setRenderProps({ options: websiteOptions });

	const createWebsiteUpdateInfo = (createdData: any) => {
		setShowLoader(true);
		try {
			requestCreateWebsiteUpdateInfo(createdData);
			showAlert('Website Update Info created');
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: any) => {
		createWebsiteUpdateInfo(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
